<div class="mitigation-item">
  <div class="mitigation-box">
    <div class="mitigation-header">
      @if (mitigation().status) {
        <mat-icon class="mitigation-status" [class]="statusClass()">
          {{ mapStatus[mitigation().status].icon }}
        </mat-icon>
      }
      <div class="mitigation-title">{{ statusText() }} {{ mitigation().mitigation }}</div>
    </div>

    @if (this.mitigation().description) {
      <div class="break-word" [innerHTML]="description()"></div>
    }
  </div>
</div>
